module.exports = __webpack_public_path__ + "img/tu8.2d20d08f.jpg";